import { DrawerId, FormId } from "components/CC/types/models.ts";
import { BaseConnectionCreatorDrawer } from "components/CC/UI/BaseConnectionCreatorDrawer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";

import { MirrorForm } from "../Forms/MirrorForm.tsx";

export const MirrorDrawer = () => {
    const { t } = usePaldockTranslation("components.connection-creator");

    return (
        <BaseConnectionCreatorDrawer drawerId={DrawerId.Mirror} title={t("nodes.mirror.drawers.title")}>
            <MirrorForm formId={FormId.MirrorForm} />
        </BaseConnectionCreatorDrawer>
    );
};
